import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ArchiveIcon from '@mui/icons-material/Archive';
import CachedIcon from '@mui/icons-material/Cached';
import { useTranslation } from 'react-i18next';
import { Notification } from '@/common/utils/index';
import styles from '@/modules/admin-access-codes/styles.less';
import { useUpdateAccessCodeStatusMutation } from '@/entities/admin-access-codes';

const ITEM_HEIGHT = 48;

const ActionsCell = ({ id, status }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const isActive = status === 'active';
  const canToggleStatus = ['active', 'disabled'].includes(status);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event?.stopPropagation?.();
    setAnchorEl(null);
  };

  const updateStatusMutation = useUpdateAccessCodeStatusMutation({
    onSuccess: (_, { payload }) => {
      handleClose();
      Notification.success(
        payload.status === 'disabled'
          ? t('Access code disabled successfully')
          : t('Access code activated successfully')
      );
    },
    onError: (error) => {
      handleClose();
      Notification.error(
        error?.message || t('Failed to update access code status')
      );
    },
  });

  const handleStatusChange = (event) => {
    event.stopPropagation();

    if (!canToggleStatus || updateStatusMutation.isPending) {
      return;
    }

    updateStatusMutation.mutate({
      id,
      payload: {
        status: isActive ? 'disabled' : 'active',
      },
    });
  };

  return (
    <div className={styles.actionsCell}>
      <IconButton
        aria-label={t('Actions')}
        aria-controls={open ? 'access-code-actions-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="access-code-actions-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '22ch',
          },
        }}
      >
        {canToggleStatus && (
          <MenuItem
            onClick={handleStatusChange}
            className={styles.actionsMenuItem}
            disabled={updateStatusMutation.isPending}
          >
            {isActive ? <ArchiveIcon /> : <CachedIcon />}
            {t(isActive ? 'Disable' : 'Activate')}
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

export const renderActionsCell = ({ row }) => (
  <ActionsCell id={row.id} status={row.status} />
);
